const django_fields_to_js_types = {
    "CharField": "string", 
    "TextField": "string"
}

function djangoFieldToJsType(django_field_name) {
    return django_fields_to_js_types[django_field_name]
}

export { djangoFieldToJsType }